export function PixelGlyphs() {
  return (
    <div className="pixel-glyphs" aria-hidden="true">
      <span className="pixel-glyph pixel-glyph--cross" />
      <span className="pixel-glyph pixel-glyph--diamond" />
      <span className="pixel-glyph pixel-glyph--steps" />
      <span className="pixel-glyph pixel-glyph--spark" />
    </div>
  );
}
